import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import FairnessInput from '../fairness/fairnessInput';
import { TranslationKeys } from '../../core/constants/translationKeys';
import FairnessButton from '../fairness/fairnessButton';
import { checkHashStore } from '../../store/checkHashStore';
import useTranslation from '../../hooks/useTranslation';
import { liveUpdateService } from '../../services/liveUpdateService';

const Calculator = observer(({ handleCopy, copiedInputType }) => {
  const {
    calculateSaltAndKey: { salt, key, hash },
  } = checkHashStore;
  const t = useTranslation();

  const handleChangeSaltAndKey = useCallback((e, inputKey) => {
    checkHashStore.setCalculateSaltAndKey({ [inputKey]: e.target.value });
  }, []);

  const handleCheckHash = useCallback(() => {
    liveUpdateService.checkResultHash({ salt, key });
  }, [key, salt]);

  useEffect(() => {
    return () => {
      checkHashStore.resetCalculateSaltAndKey();
    };
  }, []);

  return (
    <>
      <div className='input-head-wrapper'>
        <FairnessInput
          t={t}
          text={TranslationKeys.Key}
          value={key}
          type='key'
          onChangeHandler={handleChangeSaltAndKey}
        />
        <FairnessInput
          t={t}
          text={TranslationKeys.Salt}
          value={salt}
          type='salt'
          onChangeHandler={handleChangeSaltAndKey}
        />
      </div>
      <FairnessButton
        text={t(TranslationKeys.Calculate)}
        isDisabled={!salt.length || !key.length}
        handleClick={handleCheckHash}
      />
      <FairnessInput
        t={t}
        text={TranslationKeys.HashCode}
        value={hash}
        type='generate_hash'
        copiedInputType={copiedInputType}
        isShowCopyIcon
        isHashCode
        handleClick={handleCopy}
      />
    </>
  );
});
export default Calculator;
